import styled from 'styled-components';

export const PageHeader = styled.div`
  margin-bottom: 28px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 32px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 24px;
`;

export const ChartCard = styled.div`
  background: ${({ theme }) => theme.colors['neutral-0']};
  border: 2px solid ${({ theme }) => theme.colors['neutral-20']};
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
`;
